// Google initialization

$.getScript("https://apis.google.com/js/platform.js", function(){
	var google_client_id = "351154443072-0nvldf11qe5dc13dlf7hfator1g2ks3t.apps.googleusercontent.com";
	gapi.load('auth2', function(){
    // Retrieve the singleton for the GoogleAuth library and set up the client.
    auth2 = gapi.auth2.init({
      client_id: google_client_id,
      cookiepolicy: 'single_host_origin',
      // Request scopes in addition to 'profile' and 'email'
      //scope: 'additional_scope'
    });
  });
});

Jelly.Connections.Google_Sign_In = function(Parameters) {
	auth2.attachClickHandler(
			Parameters.Element

			// Options
		, {}

			// On success
		, function(googleUser) {
				google_profile = googleUser.getBasicProfile();
				
				var ID = google_profile.getId();
				var Name = google_profile.getName();
				var First_Name = google_profile.getGivenName();
				var Last_Name = google_profile.getFamilyName();
				var Email = google_profile.getEmail();
				var Path_To_Profile_Photo = google_profile.getImageUrl();

				var Namespace = Parameters.Namespace;
			
				// Save input values
				Jelly.Actions.Set_Input_Value({
						Namespace: Namespace,
						Alias: "Account_Platform",
						Value: "Google"
				});
				Jelly.Actions.Set_Input_Value({
					Namespace: Namespace,
					Alias: "Account_ID",
					Value: ID
				});
				Jelly.Actions.Set_Input_Value({
					Namespace: Namespace,
					Alias: "Email_Address",
					Value: Email
				});
				Jelly.Actions.Set_Input_Value({
					Namespace: Namespace,
					Alias: "Person_Name",
					Value: Name
				});
				Jelly.Actions.Set_Input_Value({
					Namespace: Namespace,
					Alias: "First_Name",
					Value: First_Name
				});
				Jelly.Actions.Set_Input_Value({
					Namespace: Namespace,
					Alias: "Last_Name",
					Value: Last_Name
				});	
				Jelly.Actions.Set_Input_Value({
					Namespace: Namespace,
					Alias: "Picture_URL",
					Value: Path_To_Profile_Photo
				});
				
				// Execute action.
				Jelly.Handlers.Call_Handler_For_Target({
					Event: 'Execute', 
					Target: document.getElementById(Namespace)
				});
	    }

	    // On failure
	  , function(error) {
	      // alert(JSON.stringify(error, undefined, 2));
	      if (Parameters["Error_Namespace"])
					var Error_Namespace = Parameters["Error_Namespace"];
				else
					var Error_Namespace = Parameters["Namespace"];

				Jelly.Actions.Show_Result({
					Namespace: Error_Namespace,
					Content: "Sorry! We were unable to log you in through Google."
				});
		  }
	);
} 

Jelly.Connections.Google_Sign_Out = function () {
}
 